<template>
  <div class="auth"></div>
</template>

<script src="https://cdn.auth0.com/js/lock/11.14/lock.min.js"></script>

<style lang="scss" scoped>
@import "../styles/login";
</style>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "auth",
  data() {
    return {
      data: {}
    };
  },
  computed: {
    ...mapGetters(["env"])
  },
  mounted() {
    //console.log(this.env.VUE_APP_TVI_LOGIN)
    var lock = new Auth0LockPasswordless(
      this.env.VUE_APP_TVI_LOGIN_CLINET_ID,
      "tvi.auth0.com",
      {
        allowedConnections: ["email"], // Should match the Email connection name, it defaults to 'email'
        passwordlessMethod: "code", // If not specified, defaults to 'code'
        auth: {
          redirectUrl: this.env.VUE_APP_TVI_LOGIN,
          responseType: "token id_token"
        }
      }
    );
    lock.show();

    //click close dialog
    let routeData = this.$router.resolve({ path: "/" });
    $(".auth0-lock-close-button").click(function() {
      window.open(routeData.href, "_self");
    });
  },
  components: {},
  methods: {}
};
</script>
